import { motion } from "framer-motion";

type TreatmentRow = {
  name: string;
  reason?: string;
  description?: string;
};

type TreatmentPlanSectionProps = {
  title: string;
  treatments: TreatmentRow[];
};

export function TreatmentPlanSection({ title, treatments }: Readonly<TreatmentPlanSectionProps>) {
  if (treatments.length === 0) return null;

  return (
    <motion.div
      className="flex flex-col gap-3"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <p className="text-xs uppercase tracking-wider text-secondary">{title}</p>
      <div className="flex flex-col gap-2">
        {treatments.map((treatment, i) => (
          <div
            className="flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-3"
            key={`${treatment.name}-${i}`}
          >
            <div className="min-w-0 flex-1">
              <p className="text-body1 font-semibold text-primary">{treatment.name}</p>
              {treatment.reason ? (
                <p className="mt-0.5 text-xs leading-relaxed text-secondary">{treatment.reason}</p>
              ) : null}
              {treatment.description ? (
                <p className="mt-1 text-xs leading-relaxed text-secondary">
                  {treatment.description}
                </p>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
